import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { TicketCategorySearchPage } from './ticket-category-search.page';

const routes: Routes = [
  {
    path: '',
    component: TicketCategorySearchPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [TicketCategorySearchPage]
})
export class TicketCategorySearchPageModule {}
